import { AlertTriangle } from "lucide-react";

// Ringkasan core OTB. Pemakaian aktual belum diketahui karena belum ada pemetaan core per OTB.
const NOTE = "Belum ada pemetaan core per OTB. Jumlah core kabel adalah kapasitas kabel, bukan core yang benar-benar diterminasi.";

export function OtbCoreSummary({ core, compact, testid = "otb-core-summary" }) {
  if (!core) return null;
  const used = core.pemakaian_diketahui;
  if (compact) return (
    <div className="text-xs leading-tight" data-testid={testid} title={used ? "" : NOTE}>
      <div><b>{core.kapasitas} core</b></div>
      <div className="text-[#6B7280]">{used ? `${core.terpakai} terpakai · sisa ${core.sisa} (${core.persen}%)` : "Pemakaian: belum diketahui"}</div>
      {core.kabel_melebihi_kapasitas && <div className="mt-0.5 inline-flex items-center gap-1 rounded bg-[#FEF3C7] px-1 font-semibold text-[#92400E]" data-testid={`${testid}-warn`}
        title="Kapasitas core kabel melebihi kapasitas OTB"><AlertTriangle className="h-3 w-3" />{core.kabel_melebihi_kapasitas_jumlah} kabel melebihi kapasitas OTB</div>}
    </div>);
  const kabelInfo = core.kabel_total
    ? `${core.kabel_total} kabel · core diketahui pada ${core.kabel_core_diketahui}${core.kabel_core_tidak_diketahui ? `, tanpa data core ${core.kabel_core_tidak_diketahui}` : ""}`
      + (core.core_kabel_terbesar ? ` · kabel terbesar ${core.core_kabel_terbesar} core` : "")
    : "Belum ada kabel terhubung";
  return (
    <section className="rounded border border-[#E5E7EB] p-2 text-xs" data-testid={testid}>
      <b className="uppercase text-[#6B7280]">Pemakaian Core</b>
      <dl className="mt-1 grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5">
        <dt className="text-[#6B7280]">Kapasitas</dt><dd className="font-semibold" data-testid={`${testid}-kapasitas`}>{core.kapasitas} core</dd>
        <dt className="text-[#6B7280]">Terpakai</dt><dd data-testid={`${testid}-terpakai`}>{used ? `${core.terpakai} core (${core.persen}%)` : "Belum diketahui"}</dd>
        <dt className="text-[#6B7280]">Sisa</dt><dd data-testid={`${testid}-sisa`}>{used ? `${core.sisa} core` : "Belum diketahui"}</dd>
        <dt className="text-[#6B7280]">Kabel</dt><dd data-testid={`${testid}-kabel`}>{kabelInfo}</dd>
      </dl>
      {core.kabel_melebihi_kapasitas && <p className="mt-1 text-[#B45309]" data-testid={`${testid}-warn`}>{core.kabel_melebihi_kapasitas_jumlah} kabel memiliki kapasitas core melebihi kapasitas OTB ({core.kapasitas} core) — periksa data kabel/OTB.</p>}
      {!used && <p className="mt-1 text-[11px] text-[#6B7280]">{NOTE}</p>}
    </section>
  );
}
